module.exports = __webpack_public_path__ + "img/destaque-parque-global.aa076ef5.jpg";